import { useEffect } from "react";

/**
 * Том I «Миндаль» — approved landing.
 * The landing is served as a static HTML asset from /almond-landing/ to preserve
 * the approved visual result exactly (fonts, colors, spacing, section order, images).
 * The React route /programs/almond redirects to it so the existing product URL is reused
 * without creating a duplicate route or a duplicate product.
 */
export default function AlmondLanding() {
  useEffect(() => {
    window.location.replace("/almond-landing/");
  }, []);
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#21150D",
        color: "#F5EAD8",
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: 18,
      }}
      data-testid="almond-landing-redirect"
    >
      Открываем Том I «Миндаль»…
    </div>
  );
}
